import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ContentSplitterComponent } from './content-splitter.component';
import { ContentSplitterService } from './content-splitter.service';

@NgModule({
  imports: [CommonModule, FormsModule],
  exports: [ContentSplitterComponent],
  declarations: [ContentSplitterComponent],
  providers: [ContentSplitterService],
})
export class ContentSplitterModule {}
